import * as Sentry from '@sentry/vue';
import axios from 'axios';

export default class {
    constructor() {
        this.http = axios.create({
            baseURL: process.env.VUE_APP_BASE_API_URL
        });

        this.http.interceptors.response.use(function(response) {
            return response;
        }, function(err) {
            // Sentry.captureException(err);
            Sentry.captureMessage('An error occurred: ' + JSON.stringify(err));
            return Promise.reject(err);
        });
    }

    searchApi() {
        const mapHash = process.env.VUE_APP_MAP_HASH;
        return {
            searchBuilding: (data) => {
                const url = '/api/buildingid/lookup/montgomery';
                return this.http.post(url, data);
            },
            searchBuildingById: (data) => {
                const url = '/api/buildingid/lookup-id/montgomery';
                return this.http.post(url, data);
            },
            searchBPSLookup: (id) => {
                const url = `/api/bpscalculator/lookup-id/${id}/${mapHash}`;
                return this.http.get(url);
            },
        };
    };

    buildingsApi() {
        return {
            inventory: () => {
                const url = '/api/montgomery-building-inventory';
                return this.http.get(url);
            },
            downloadUrl: () => {
                return process.env.VUE_APP_BASE_API_URL + '/api/montgomery-building-inventory/download';
            },
        };
    }
};
